export const name = "MAKE_INTERVAL";
export const summary = `Constructs an \`INTERVAL\` value.`;
export const reference = `
## MAKE_INTERVAL

Constructs an \`INTERVAL\` value.

\`\`\`
MAKE_INTERVAL(
  [[ year =>] value ]
  [, [month =>] value ]
  [, [day =>] value ]
  [, [hour =>] value ]
  [, [minute =>] value ]
  [, [second =>] value ]
)
\`\`\`

### Description

Constructs an \`INTERVAL\` object using \`INT64\` values representing the year, month, day, hour, minute, and second. All arguments are optional, \`0\` by default, and can be named arguments.


### Return Data Type

\`INTERVAL\`


### Example



\`\`\`
SELECT
  MAKE_INTERVAL(1, 6, 15) AS i1,
  MAKE_INTERVAL(hour => 10, second => 20) AS i2,
  MAKE_INTERVAL(1, minute => 5, day => 2) AS i3

/*--------------+---------------+-------------*
 | i1 | i2 | i3 |
 +--------------+---------------+-------------+
 | 1-6 15 0:0:0 | 0-0 0 10:0:20 | 1-0 2 0:5:0 |
 *--------------+---------------+-------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
`;
